import React, { useEffect, useState } from "react";
import { getActiveMerchants } from "../../../../../api";
import MenuIcon40 from "../../../../assets/svg/icons/common/MenuIcon40";
import TrendDown24 from "../../../../assets/svg/icons/common/TrendDown24";
import TrendUp24 from "../../../../assets/svg/icons/common/TrendUp24";
import SkeletonLoader from "../../../../components/skeleton-loader";
import SlidingTab from "../../../../components/SlidingTab/SlidingTab";
import useDashboardStore from "../../../../stores/dashboard";
import MerchantNameLink from "../../../../components/MerchantNameLink";
import styles from "./style.module.scss";

const formatNumber = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + "B";
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + "M";
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + "K";
  }
  return num.toString();
};

const ActiveMerchant = () => {
  const filterDataStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterDataEndDate = useDashboardStore((s) => s.filterData.endDate);
  const filterData = useDashboardStore((s) => s.filterData);

  const [activeMerchants, setActiveMerchants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("top");

  useEffect(() => {
    setLoading(true);
    getActiveMerchants({
      start_date: filterDataStartDate,
      end_date: filterDataEndDate,
      org_id: filterData.filterOrgTemp,
      type: type,
    })
      .then((res) => {
        if (res.status) {
          setActiveMerchants(res.data);
        }
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }, [type, filterDataStartDate, filterDataEndDate, filterData]);

  return (
    <div className={styles.activeMerchant}>
      <div className={styles.activeMerchantHeader}>
        <div className={styles.activeMerchantHeaderContent}>
          <p className={styles.activeMerchantHeaderTitle}>Active Merchant</p>
          <p className={styles.activeMerchantHeaderDate}>
            {new Date(filterDataStartDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}{" "}
            -{" "}
            {new Date(filterDataEndDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
            })}
          </p>
        </div>

        <div className={styles.activeMerchantHeaderActions}>
          <SlidingTab
            options={["Top", "Low"]}
            onChange={(value) => {
              setType(value.toLowerCase());
            }}
          />
        </div>
      </div>
      {loading && (
        <div className={styles.activeMerchantList}>
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className={styles.activeMerchantListItem}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  width: "100%",
                }}
              >
                <SkeletonLoader
                  variant="rectangular"
                  height={"20px"}
                  width={"100%"}
                  style={{
                    borderRadius: "8px",
                  }}
                />
                <SkeletonLoader
                  variant="rectangular"
                  height={"16px"}
                  width={"75px"}
                  style={{
                    borderRadius: "8px",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {activeMerchants?.length > 0 ? (
        <div className={styles.activeMerchantList}>
          {activeMerchants.map((merchant, index) => (
            <div key={index} className={styles.activeMerchantListItem}>
              <div className={styles.activeMerchantListItemContent}>
                <p className={styles.activeMerchantListItemTitle}>
                  <MerchantNameLink powerappId={merchant.powerapp_id}>
                    {merchant.powerapp_name}
                  </MerchantNameLink>
                </p>
                {/* <p className={styles.activeMerchantListItemDescription} >{merchant.total_sales.toLocaleString()}</p> */}
              </div>

              <div className={styles.amountContainer}>
                <p
                  className={styles.amountValue}
                  style={{
                    color: merchant.trend === "down" ? "#E03B24" : undefined,
                  }}
                >
                  ${formatNumber(merchant.total_sales)}
                </p>
              </div>

              <div className={styles.trendContainer}>
                <span className={styles.trendIcon}>
                  {merchant.trend == "up" ? <TrendUp24 /> : <TrendDown24 />}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyContainer}>
          <div className={styles.iconBox}>
            <MenuIcon40 />
          </div>

          <p className={styles.emptyTitle}>
            This list will display merchants with the highest and lowest
            performance based on sales volume and goal completion
          </p>
        </div>
      )}
    </div>
  );
};

export default ActiveMerchant;
